<div class="modal" id="riderDetail" tabindex="-1">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="container-fluid bg-light-gray p-0">
          <div class="row row-cols-1 m-0 gy-2 justify-content-center">
            <div class="col mt-0 p-0 bg-primary-white navbar-spacer">
              <app-navbar
                class="fixed-top"
                [isShowBackButton]="true"
                [preventDefaultGoBack]="true"
                (goBackCallback)="hide()"
                [inputTitle]="'app.navbar.riderDetails'"
              />
            </div>
            <div
              class="col col-lg-6 row row-cols-1 gx-4 gy-2 pt-2 pb-4 bg-primary-white mx-0"
            >
              <div class="col">
                <div class="fs-2 fw-bold text-secondary-purple mb-3">
                  {{ 'app.navbar.riderProfile' | translate }}
                </div>
                <!-- <div class="fs-5 fw-bold text-secondary-purple">
                  <img
                    [src]="rider?.photoUrl() ?? '/images/avatar.jpg'"
                    onerror="this.src='/images/avatar.jpg';this.onerror=null"
                    class="img-thumbnail mb-2"
                    style="width: 150px; height: 150px"
                  />
                  <div>{{ rider?.name?.enName }}</div>
                  <div class="mt-1">{{ rider?.name?.cnName }}</div>
                </div> -->
              </div>
              <!-- <div class="col">
                <div class="row row-cols-2 gy-2">
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.gender' | translate }}
                    </div>
                    <div class="fs-5">
                      {{ `app.details.${rider?.gender}` | translate }}
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.dateOfBirth' | translate }}
                    </div>
                    <div class="fs-5">
                      {{ rider?.birthDate! | myDate }}
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.age' | translate }}
                    </div>
                    <div class="fs-5">
                      @if (rider?.age) {
                        {{ rider?.age }}
                        {{ 'app.details.yearsOld' | translate }}
                      } @else {
                        
                      }
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.height' | translate }}
                    </div>
                    <div class="fs-5">
                      @if (rider?.height) {
                        {{ rider?.height }}
                      } @else {
                        
                      }
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.weight' | translate }}
                    </div>
                    <div class="fs-5">
                      @if (rider?.weight) {
                        {{ rider?.weight }}
                      } @else {
                        
                      }
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.headSize' | translate }}
                    </div>
                    <div class="fs-5">
                      @if (rider?.headSize) {
                        {{ rider?.headSize }}
                      } @else {
                        
                      }
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.school' | translate }}
                </div>
                <div class="fs-5">
                  @if (rider?.school?.name) {
                    {{ rider?.school?.name }}
                  } @else {
                    
                  }
                </div>
              </div>
              <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.disability' | translate }}
                </div>
                <div class="fs-5">
                  @let diaStr = rider?.diagnosis?.diagnosisStr;
                  @if (diaStr) {
                    {{ diaStr }}
                  } @else {
                    {{ 'app.details.noDisability' | translate }}
                  }
                </div>
              </div> -->
              <!-- <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.physicalAbility' | translate }}
                </div>
                <div class="fs-5">
                  @let mobility = rider?.diagnosis?.mobility;
                  @if (mobility === 'others') {
                    {{ rider?.diagnosis?.otherMobility }}
                  } @else if (mobility) {
                    {{ `app.mobility.${mobility}` | translate }}
                  } @else {
                    
                  }
                </div>
              </div> -->
              <!-- <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.walk' | translate }}
                </div>
                <div class="fs-5">
                  {{
                    `app.details.${rider?.canWalk() ? 'yes' : 'no'}` | translate
                  }}
                </div>
              </div>
              <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.medication' | translate }}
                </div>
                <div class="fs-5">
                  @if (rider?.medication) {
                    {{ rider?.medication }}
                  } @else {
                    {{ 'app.details.noMedication' | translate }}
                  }
                </div>
              </div>
              <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.previousRidingExperience' | translate }}
                </div>
                <div class="fs-5">
                  @if (rider?.ridingExperience) {
                    {{ rider?.ridingExperience }}
                  } @else {
                    {{ 'app.details.noExperience' | translate }}
                  }
                </div>
              </div> -->
              <!-- <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.others' | translate }}
                </div>
                <div class="fs-5">
                  @if (rider?.agreeTakePhoto) {
                    {{ 'app.details.agreeTakePhoto' | translate }}
                  } @else {
                    {{ 'app.details.disagreeTakePhoto' | translate }}
                  }
                </div>
              </div> -->
              @if (isCoach()) {
                <div class="col">
                  <!-- <div class="fs-5 fw-bold text-secondary-purple mb-3">
                    {{
                      'app.details.informationShownOnVolunteerCoach' | translate
                    }}
                  </div> -->
                  <div class="rider-profile-card">
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.term' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (clazz?.name) {
                            {{ clazz?.name }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.day' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (clazz?.date) {
                            {{ clazz?.date ?? '' | myDate: true }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.time' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (
                            clazz?.shortTimeStart() && clazz?.shortTimeEnd()
                          ) {
                            {{ clazz?.shortTimeStart() }} -
                            {{ clazz?.shortTimeEnd() }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.school' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (clazz?.venue) {
                            {{ clazz?.venue }}
                          } @else {}
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.riderFullName' | translate }}
                        </div>
                        <div class="profile-value">
                          <div>{{ rider?.name?.enName }}</div>
                          <div class="mt-1">{{ rider?.name?.cnName }}</div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.gender' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.gender) {
                            {{ `app.details.${rider?.gender}` | translate }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.nationality' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.nationality) {
                            {{ rider?.nationality }}
                          } @else {}
                        </div>
                      </div>
                      <!-- <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.languageUsed' | translate }}
                        </div>
                        <div class="profile-value profile-value-italic">
                          @if (rider?.language) {
                            {{ rider?.language }}
                          } @else {}
                        </div>
                      </div> -->
                      <div class="col-12">
                        <div class="profile-label">
                          {{
                            'app.details.photographsFilmingConsent' | translate
                          }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.agreeTakePhoto) {
                            <span
                              class="pill-consent-agree d-inline-flex align-items-center gap-1"
                            >
                              <i class="fas fa-circle-check"></i>
                              {{ 'app.details.agreeTakePhoto' | translate }}
                            </span>
                          } @else {
                            <span
                              class="pill-consent-disagree d-inline-flex align-items-center gap-1"
                            >
                              <i class="fas fa-ban"></i>
                              {{ 'app.details.disagreeTakePhoto' | translate }}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div
                      class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 profile-row"
                    >
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.weight' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.weight) {
                            {{ rider?.weight }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.height' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.height) {
                            {{ rider?.height }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.headSize' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.headSize) {
                            {{ rider?.headSize }}
                          } @else {}
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.disability' | translate }}
                        </div>
                        <div class="profile-value">
                          @let coachDiagLines = riderDisabilityLines(rider!);
                          @if (coachDiagLines.length) {
                            @for (line of coachDiagLines; track $index) {
                              <div>{{ line }}</div>
                            }
                          }
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.medication' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.medication) {
                            {{ rider?.medication }}
                          }
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{
                            'app.details.previousRidingExperience' | translate
                          }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.ridingExperience) {
                            {{ rider?.ridingExperience }}
                          }
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.walkingAids' | translate }}
                        </div>
                        <div class="profile-value">
                          @let coachMobility = rider?.diagnosis?.mobility;
                          @if (coachMobility === 'others') {
                            {{ rider?.diagnosis?.otherMobility }}
                          } @else if (coachMobility) {
                            {{ `app.mobility.${coachMobility}` | translate }}
                          } @else {}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              } @else {
                <div class="col">
                  <!-- <div class="fs-5 fw-bold text-secondary-purple mb-3">
                    {{ 'app.details.informationShownOnVolunteer' | translate }}
                  </div> -->
                  <div class="rider-profile-card">
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.term' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (clazz?.name) {
                            {{ clazz?.name }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.day' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (clazz?.date) {
                            {{ clazz?.date ?? '' | myDate: true }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.time' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (
                            clazz?.shortTimeStart() && clazz?.shortTimeEnd()
                          ) {
                            {{ clazz?.shortTimeStart() }} -
                            {{ clazz?.shortTimeEnd() }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.school' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (clazz?.venue) {
                            {{ clazz?.venue }}
                          } @else {}
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.riderFullName' | translate }}
                        </div>
                        <div class="profile-value">
                          <div>{{ rider?.name?.enName }}</div>
                          <div class="mt-1">{{ rider?.name?.cnName }}</div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.gender' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.gender) {
                            {{ `app.details.${rider?.gender}` | translate }}
                          } @else {}
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.nationality' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.nationality) {
                            {{ rider?.nationality }}
                          } @else {}
                        </div>
                      </div>
                      <!-- <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.languageUsed' | translate }}
                        </div>
                        <div class="profile-value profile-value-italic">
                          @if (rider?.language) {
                            {{ rider?.language }}
                          } @else {}
                        </div>
                      </div> -->
                      <div class="col-12">
                        <div class="profile-label">
                          {{
                            'app.details.photographsFilmingConsent' | translate
                          }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.agreeTakePhoto) {
                            <span
                              class="pill-consent-agree d-inline-flex align-items-center gap-1"
                            >
                              <i class="fas fa-circle-check"></i>
                              {{ 'app.details.agreeTakePhoto' | translate }}
                            </span>
                          } @else {
                            <span
                              class="pill-consent-disagree d-inline-flex align-items-center gap-1"
                            >
                              <i class="fas fa-ban"></i>
                              {{ 'app.details.disagreeTakePhoto' | translate }}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.headSize' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.headSize) {
                            {{ rider?.headSize }}
                          } @else {}
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 g-4 profile-row">
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.disability' | translate }}
                        </div>
                        <div class="profile-value">
                          @let volDiagLines = riderDisabilityLines(rider!);
                          @if (volDiagLines.length) {
                            @for (line of volDiagLines; track $index) {
                              <div>{{ line }}</div>
                            }
                          }
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.medication' | translate }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.medication) {
                            {{ rider?.medication }}
                          }
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{
                            'app.details.previousRidingExperience' | translate
                          }}
                        </div>
                        <div class="profile-value">
                          @if (rider?.ridingExperience) {
                            {{ rider?.ridingExperience }}
                          }
                        </div>
                      </div>
                      <div class="col">
                        <div class="profile-label">
                          {{ 'app.details.walkingAids' | translate }}
                        </div>
                        <div class="profile-value">
                          @let volMobility = rider?.diagnosis?.mobility;
                          @if (volMobility === 'others') {
                            {{ rider?.diagnosis?.otherMobility }}
                          } @else if (volMobility) {
                            {{ `app.mobility.${volMobility}` | translate }}
                          } @else {}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- <div class="col my-4">
                <div class="border-top"></div>
              </div>
              <div class="col">
                <div class="row row-cols-2">
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.volunteerAssigned' | translate }}
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary">
                      {{ 'app.details.assignedTask' | translate }}
                    </div>
                  </div>
                </div>
                <div class="row row-cols-2">
                  <div class="col">
                    <div class="fs-5">
                      @let leaderName = rider?.assignedVolunteers?.leader?.name;
                      @if (leaderName?.cnName || leaderName?.enName) {
                        <div>{{ leaderName?.enName ?? '' }}</div>
                        <div>{{ leaderName?.cnName ?? '' }}</div>
                      } @else {
                        <div>{{ 'app.details.notAssigned' | translate }}</div>
                      }
                    </div>
                  </div>
                  <div class="col">
                    <div class="fs-5">
                      {{ 'app.details.leader' | translate }}
                    </div>
                  </div>
                </div>
                <div class="row row-cols-2">
                  <div class="col">
                    <div class="fs-5">
                      @let helperName = rider?.assignedVolunteers?.helper?.name;
                      @if (helperName?.cnName || helperName?.enName) {
                        <div>{{ helperName?.enName ?? '' }}</div>
                        <div>{{ helperName?.cnName ?? '' }}</div>
                      } @else {
                        <div>{{ 'app.details.notAssigned' | translate }}</div>
                      }
                    </div>
                  </div>
                  <div class="col">
                    <div class="fs-5">
                      {{ 'app.details.sideHelper' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.horseAssigned' | translate }}
                </div>
                <div class="fs-5">
                  @if (rider?.assignedHorse?.id) {
                    {{
                      `${rider?.assignedHorse?.id} ${rider?.assignedHorse?.name}`
                    }}
                  } @else {
                    {{ 'app.details.notAssigned' | translate }}
                  }
                </div>
              </div>
              <div class="col">
                <div class="text-secondary">
                  {{ 'app.details.equipmentAssigned' | translate }}
                </div>
                <div class="fs-5">
                  @if (rider?.assignedEquipment?.name) {
                    {{ rider?.assignedEquipment?.name }}
                  } @else {
                    {{ 'app.details.notAssigned' | translate }}
                  }
                </div>
              </div> -->
            </div>
            <div class="col col-lg-6 px-4 py-3 bg-primary-white">
              <div class="fs-2 fw-bold text-secondary-purple mb-3">
                {{ 'app.assessment.assessment' | translate }}
              </div>
              @if (!isAssessmentLoading) {
                <div class="row gy-3 align-items-center">
                  <div class="col-7 fs-5 fw-bold">
                    {{ 'app.assessment.communication' | translate }}
                  </div>
                  <div class="col-5">
                    <select
                      [formControl]="
                        assessmentControls().controls.communication
                      "
                      class="form-select form-select-lg"
                    >
                      <option value="5+">5+</option>
                      <option value="5">5</option>
                      <option value="4+">4+</option>
                      <option value="4">4</option>
                      <option value="3+">3+</option>
                      <option value="3">3</option>
                      <option value="2+">2+</option>
                      <option value="2">2</option>
                      <option value="1+">1+</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                  <div class="col-7 fs-5 fw-bold">
                    {{ 'app.assessment.confident' | translate }}
                  </div>
                  <div class="col-5">
                    <select
                      [formControl]="assessmentControls().controls.confident"
                      class="form-select form-select-lg"
                    >
                      <option value="5+">5+</option>
                      <option value="5">5</option>
                      <option value="4+">4+</option>
                      <option value="4">4</option>
                      <option value="3+">3+</option>
                      <option value="3">3</option>
                      <option value="2+">2+</option>
                      <option value="2">2</option>
                      <option value="1+">1+</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                  <div class="col-7 fs-5 fw-bold">
                    {{ 'app.assessment.enjoyment' | translate }}
                  </div>
                  <div class="col-5">
                    <select
                      [formControl]="assessmentControls().controls.enjoyment"
                      class="form-select form-select-lg"
                    >
                      <option value="5+">5+</option>
                      <option value="5">5</option>
                      <option value="4+">4+</option>
                      <option value="4">4</option>
                      <option value="3+">3+</option>
                      <option value="3">3</option>
                      <option value="2+">2+</option>
                      <option value="2">2</option>
                      <option value="1+">1+</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                  <div class="col-7 fs-5 fw-bold">
                    {{ 'app.assessment.horsemanship' | translate }}
                  </div>
                  <div class="col-5">
                    <select
                      [formControl]="assessmentControls().controls.horsemanship"
                      class="form-select form-select-lg"
                    >
                      <option value="5+">5+</option>
                      <option value="5">5</option>
                      <option value="4+">4+</option>
                      <option value="4">4</option>
                      <option value="3+">3+</option>
                      <option value="3">3</option>
                      <option value="2+">2+</option>
                      <option value="2">2</option>
                      <option value="1+">1+</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                  <div class="col-7 fs-5 fw-bold">
                    {{ 'app.assessment.physicalChange' | translate }}
                  </div>
                  <div class="col-5">
                    <select
                      [formControl]="
                        assessmentControls().controls.physicalChange
                      "
                      class="form-select form-select-lg"
                    >
                      <option value="5+">5+</option>
                      <option value="5">5</option>
                      <option value="4+">4+</option>
                      <option value="4">4</option>
                      <option value="3+">3+</option>
                      <option value="3">3</option>
                      <option value="2+">2+</option>
                      <option value="2">2</option>
                      <option value="1+">1+</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                  <div class="col-12">
                    <textarea
                      [formControl]="assessmentControls().controls.remark"
                      class="form-control"
                      rows="5"
                    ></textarea>
                  </div>
                  <div class="col-12">
                    <div
                      class="d-flex justify-content-between align-items-baseline py-2 border-bottom"
                    >
                      <span class="profile-label mb-0">
                        {{ 'app.assessment.assessor' | translate }}
                      </span>
                      <span class="profile-value fs-6 text-end">
                        {{ displayName(assessment()?.assessor?.name) }}
                      </span>
                    </div>
                  </div>
                  @if (showConfirmer()) {
                    <div class="col-12">
                      <div
                        class="d-flex justify-content-between align-items-baseline py-2 border-bottom"
                      >
                        <span class="profile-label mb-0">
                          {{ 'app.assessment.confirmer' | translate }}
                        </span>
                        <span class="profile-value fs-6 text-end">
                          {{ displayName(assessment()?.confirmer?.name) }}
                        </span>
                      </div>
                    </div>
                  }
                  <div class="col">
                    <button
                      (click)="onConfirmClick()"
                      [disabled]="disableUpdate()"
                      class="btn btn-primary w-100"
                    >
                      @if (isCoach()) {
                        {{ 'app.assessment.confirm' | translate }}
                      } @else if (canSubmit()) {
                        {{ 'app.assessment.submit' | translate }}
                      } @else {
                        {{
                          'app.assessment.assessmentUpdateSuccessfully'
                            | translate
                        }}
                      }
                      @if (isAssessmentUpdating) {
                        <div
                          class="spinner-border spinner-border-sm text-light"
                        ></div>
                      }
                    </button>
                  </div>
                </div>
              } @else {
                <div class="ratio ratio-1x1">
                  <div class="d-grid align-items-center justify-content-center">
                    <div class="spinner-border text-secondary-purple"></div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="confirmAssessment" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h5 class="modal-title fs-5 fw-bold">
          {{ 'app.assessment.confirmTitle' | translate }}
        </h5>
      </div>
      <div class="modal-body">
        {{ 'app.assessment.confirmMessage' | translate }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{ 'app.assessment.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="updateAssessment()"
        >
          {{ 'app.assessment.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
